import * as React from 'react';

export default function ButtonCall() {
	return (
		<a href="tel:+1234567890" className="inline-block px-3 py-2 bg-primary text-white font-display text-base md:text-lg uppercase hover:bg-primary-dark transition duration-300">
			Call (123)456-7890
		</a>
	);
}
